import './Patisserie.css';
import alexandra from '../../assets/images/green_patti.jpg';
import macarons from '../../assets/images/macarons.jpg';
import toertchen from '../../assets/images/toertchen.jpg';

function Patisserie() {
  return (
    <section className="patisserie">
      <div className="patisserie__inner">
        <div className="patisserie__header">
          <span className="patisserie__label">Süßes &amp; Backkunst</span>
          <h2 className="patisserie__title">Original französische Pâtisserie</h2>
          <div className="patisserie__divider" />
        </div>

        <div className="patisserie__images">
          <div className="patisserie__img-wrap">
            <img src={alexandra} alt="Alexandra Wende – Pâtissière" className="patisserie__img patisserie__img--top" />
          </div>
          <div className="patisserie__img-wrap">
            <img src={macarons} alt="Macarons" className="patisserie__img patisserie__img--top" />
          </div>
          <div className="patisserie__img-wrap">
            <img src={toertchen} alt="Törtchen" className="patisserie__img" />
          </div>
        </div>

        <p className="patisserie__text">
          Täglich frisch gebacken – original französische Pâtisserie, vieles davon glutenfrei.
          Auf Wunsch fertigen wir auch individuelle Torten und Signature Cakes für besondere Anlässe.
        </p>
      </div>
    </section>
  );
}

export default Patisserie;
